import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PersonalAccessTokenService } from './services/personalaccesstoken.service';

export function provideCorePersonalAccessTokenDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([PersonalAccessTokenService]);
}
